// src/Home.jsx - Updated to prevent multiple loads
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [mapError, setMapError] = useState('');

  useEffect(() => {
    // Check if already loaded
    if (window.google && window.google.maps) {
      initMap();
      return;
    }

    // Check if script is already being loaded
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      // Wait for existing script to load
      window.initMap = initMap;
      return;
    }

    // Load script once
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA1X6s1ktlISP6QvxGHn1uq2-R7qle9BRs&libraries=places&callback=initMap`;
    script.async = true;
    script.defer = true;
    script.id = 'google-maps-script';
    
    window.initMap = initMap;
    
    script.onerror = () => {
      setMapError('Failed to load Google Maps');
      setMapLoaded(false);
    };
    
    document.head.appendChild(script);

    function initMap() {
      try {
        if (mapRef.current && window.google) {
          const location = { lat: 37.7749, lng: -122.4194 };
          
          new window.google.maps.Map(mapRef.current, {
            zoom: 12,
            center: location,
          });
          
          setMapLoaded(true);
        }
      } catch (error) {
        setMapError(error.message);
      }
    }

    return () => {
      // Clean up callback
      window.initMap = undefined;
    };
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px', padding: '0 20px' }}>
      <h1>Google Maps Dynamic Map</h1>
      
      {mapError && (
        <div style={{ color: 'red', padding: '20px' }}>
          <p>Error loading map: {mapError}</p>
          <p>Please enable Maps JavaScript API in Google Cloud Console</p>
        </div>
      )}
      
      <div style={{ position: 'relative', height: '500px', width: '100%' }}>
        <div ref={mapRef} style={{ height: '100%', width: '100%' }} />
        {!mapLoaded && !mapError && <div>Loading map...</div>}
      </div>
      
      <button onClick={() => navigate('/register')}>Go to Register</button>
    </div>
  );
};

export default Home;